import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,

  selector: 'lib-message-center-header',
  imports: [],
  templateUrl: './message-center-header.component.html',
  styleUrl: './message-center-header.component.scss'
})
export class MessageCenterHeaderComponent {
  @Input() public unreadCount: number = 0;
  @Output() newMessageSelected: EventEmitter<void> = new EventEmitter<void>();

  public handleNewMessage() {
    this.newMessageSelected.emit();
  }
}
